// Simpanan ROI dan garis hitung operator per kamera di localStorage.
// Override ini menimpa bawaan src/data/cameraRoi.json. Karena belum boleh
// deploy, data operator disimpan lokal; saat disetujui Andra, data ini dapat
// dikirim ke backend (tabel kamera / endpoint simpan ROI) tanpa ubah bentuk.

const KUNCI = 'horus_cctv_roi_v1';

export function bacaSemua() {
  try {
    const raw = localStorage.getItem(KUNCI);
    const obj = raw ? JSON.parse(raw) : {};
    return obj && typeof obj === 'object' ? obj : {};
  } catch {
    return {};
  }
}

export function bacaKamera(id) {
  return bacaSemua()[id] || null;
}

export function simpanKamera(id, data) {
  const semua = bacaSemua();
  semua[id] = data;
  try { localStorage.setItem(KUNCI, JSON.stringify(semua)); } catch { /* storage bisa diblokir */ }
  return semua;
}

export function hapusKamera(id) {
  const semua = bacaSemua();
  delete semua[id];
  try { localStorage.setItem(KUNCI, JSON.stringify(semua)); } catch { /* noop */ }
  return semua;
}
